const handleMintInput = (number) => {
	if (number === null || number === undefined || number === "") {
		return "Please enter a valid number";
	} else if (number == 0) {
		return "Mint amount cannot be 0";
	} else if (number < 0) {
		return "Mint amount cannot be less than zero";
	} else if (isNaN(number)) {
		return "Please enter a valid number";
	} else {
		return "";
	}
};
export default handleMintInput;
